
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { childItemsFacet } from '../../facets/SetFacets';
import { itemPageIsBlocked } from '../../operations/blockItemPage';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { css } from '@uifabric/utilities/lib/css';
import * as ItemPageStyles from './ItemPage.scss';
import { getConfiguration } from '../../models/configuration/getConfiguration';
import { enableListLoadingSpinnerFacet } from '../../facets/ConfigurationFacets';

/**
 * Props for an ItemPage.
 * @public
 */
export interface IItemPageProps {
    /**
     * The key for a page item.
     */
    itemKey: string;
    layout?: 'none' | 'row' | 'tile';
    contentSize?: {
        width: number;
        height: number;
    };
}

/**
 * Component which renders empty content, while demanding the child items
 * for a page with the given input item key.
 *
 * Render this component within a virtualized list to force expansion of the
 * paged items only when the list needs to render the content.
 * @public
 */
export class ItemPage extends React.PureComponent<IItemPageProps> {
    public render(): JSX.Element {
        const {
            itemKey,
            layout = 'none'
        } = this.props;

        return (
            <WithItemCache>
                { ({ itemCache }: IItemCacheStateProps) => {
                    const isBlocked = itemPageIsBlocked(itemCache);
                    const {
                        enableListLoadingSpinner
                    } = getConfiguration(itemCache, {
                        enableListLoadingSpinner: enableListLoadingSpinnerFacet
                    });

                    // When the component is finally rendered, demand the child items for the page.
                    if (!isBlocked) {
                        itemCache.demandItemFacet(childItemsFacet, itemKey);
                    }

                    return (
                        layout !== 'none' ? (
                            <div
                                className={ css(ItemPageStyles.root, layout === 'row' ? ItemPageStyles.row : ItemPageStyles.tile) }
                            >
                                {
                                    enableListLoadingSpinner ? (
                                        <Spinner />
                                    ) : null
                                }
                            </div>
                        ) : null
                    );
                } }
            </WithItemCache>
        );
    }
}
